import { render } from "./Main.vue?vue&type=template&id=e91f8706"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
script.render = render

export default script